import styles from './HeaderButton.module.scss'
import {phone} from '../../utils/data'

const HeaderButton = () => {

    return (
        <div className={styles.box}>
        <ul className={styles.list}>

            <li className={styles.item}>
                <a className={styles.link_telegram} target='_blank' rel='noopener noreferrer' href={'https://t.me/' + phone} aria-label='телеграмм'>
                    <svg className={styles.image_icon} aria-hidden="true" focusable="false" data-prefix="fab" data-icon="telegram-plane" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="#FFF" d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>
                </a>
            </li>
            <li className={styles.item_phone}>
                <a className={styles.link_telegram} target='_blank' rel='noopener noreferrer' href={"tel:" + phone} aria-label='позвонить'>
                <svg className={styles.image_icon} width="24" height="24" viewBox="0 0 24 24" fill="#FFF" xmlns="http://www.w3.org/2000/svg">
				<path d="M20.023 15.488C19.393 15.473 18.6 15.436 18.099 15.348C17.557 15.252 16.905 15.066 16.446 14.923C16.086 14.811 15.694 14.91 15.427 15.176L13.21 17.38C11.678 16.573 10.451 15.633 9.412 14.588C8.367 13.549 7.427 12.322 6.62 10.79L8.824 8.572C9.09 8.305 9.189 7.913 9.077 7.553C8.935 7.095 8.748 6.443 8.653 5.901C8.564 5.4 8.528 4.607 8.512 3.977C8.499 3.432 8.055 3 7.51 3H4C3.562 3 3 3.328 3 4C3 8.539 4.84 12.874 7.966 16.034C11.126 19.16 15.461 21 20 21C20.672 21 21 20.438 21 20V16.49C21 15.945 20.568 15.501 20.023 15.488Z">
				</path>
			</svg>
                </a>
            </li>
        </ul>
        </div>
    );
};

export default HeaderButton